import React, {PropTypes} from 'react';
import {Table} from 'react-bootstrap';

const myTable = props => {
  let {head, items} = props;
  let tableHead = head.length > 0 ? (<thead>
  <tr>
    {head.map((h, i) => {
      return <th key={i}>{h}</th>;
    })}
  </tr>
  </thead>) : null;
  let tableBody = items.length > 0 ? (<tbody>
  {items.map((item, i) => {
    return (
      <tr key={i}>
        {item.map((value, j) => {
          return (<td key={j}>{value}</td>);
        })}
      </tr>
    );
  })}
  </tbody>) : null;
  return (
    <Table className="table-striped table-borderless">
      {tableHead}
      {tableBody}
    </Table>
  );
};

myTable.propTypes = {
  head: PropTypes.array,
  items: PropTypes.array.isRequired
};

myTable.defaultProps = {
  head: []
};

export default myTable;



/** WEBPACK FOOTER **
 ** ./src/modules/ui/components/Table.js
 **/